import React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/loading_spinner'. 'node_modules/@grnhse/seedling/lib/azalea/components/loading_spinner.js' implicitly has an 'any' type.
import LoadingSpinner from '@grnhse/seedling/lib/azalea/components/loading_spinner';

export default function Loading() {
  return (
    <LoadingSpinner
      size="medium"
      style={{ display: 'block', margin: '1em auto' }}
    />
  );
}
